import React, { useEffect, useState } from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { invoiceAdvanceDenormalizedEntries } from 'provider/queries/hasuraQueries'
import { ArrayField, useTranslate } from 'react-admin'
import addEventsToProps from 'utils/addEventsToProps'
import { post as getFromHasura } from 'utils/axios'

import { white } from '../../constants/colorConstants'
import { StatusDetailDescriptionField } from '../fields/statusDetailDescriptionField'
import { StatusDetailTitleField } from '../fields/statusDetailTitleField'
import { StatusField } from '../fields/statusField'
import { EventInvoiceList } from '../lists/eventInvoiceList'
import expandableViewStyles from './styles'

const useStyles = makeStyles((theme) => ({
  ...expandableViewStyles,
  tableColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    backgroundColor: white,
    width: '768px',
    borderRadius: '8px',
  },
  importerName: {
    fontSize: '18px',
    lineHeight: '21.6px',
    ...theme.mundi.font.lato700Normal,
  },
  invoiceId: {
    fontSize: '14px',
    lineHeight: '16.41px',
    marginTop: '8px',
    ...theme.mundi.font.roboto400Normal,
  },
  status: {
    whiteSpace: 'nowrap',
    marginTop: '44px',
    ...theme.mundi.font.roboto700Normal,
  },
  statusTitle: {
    ...theme.mundi.font.roboto400Normal,
  },
  statusDescription: {
    ...theme.mundi.font.roboto500Normal,
  },
}))

export const EventsInvoiceExpandableView = ({
  linkDataCreditLines,
  ...props
}) => {
  const classes = useStyles()
  const translate = useTranslate()
  const [shouldLink, setShouldLink] = useState(false)
  const [url, setUrl] = useState(undefined)
  const [entries, setInvoiceEntries] = useState({})

  useEffect(() => {
    async function fetchEntries() {
      const entriesRes = await getFromHasura({
        payload: invoiceAdvanceDenormalizedEntries('invoice_advance_id'),
        variables: {
          invoice_advance_id: props.record.id,
        },
      })

      if (entriesRes.errors?.length) {
        console.error(JSON.stringify(entriesRes.errors[0]))
        return
      }

      setInvoiceEntries(
        addEventsToProps(
          props.record,
          entriesRes.data.invoiceadvance_view_denormalized_entries
        )
      )
    }

    fetchEntries()
  }, [props.record])

  const creditLineId = props.record.creditLine

  useEffect(() => {
    if (linkDataCreditLines !== undefined) {
      const filter = linkDataCreditLines.filter(
        (item) => item.id === creditLineId
      )
      const currentLinkData = filter?.length > 0 ? filter[0] : undefined
      if (currentLinkData === undefined) return setShouldLink(false)
      const page =
        linkDataCreditLines.indexOf(currentLinkData) >= 0
          ? Math.floor(linkDataCreditLines.indexOf(currentLinkData) / 10) + 1
          : 1
      setUrl(
        `/creditlines?page=${page}&perPage=10&selectedItemId=${creditLineId}`
      )
    }
  }, [linkDataCreditLines, creditLineId])

  useEffect(() => {
    if (shouldLink && url !== undefined) {
      setShouldLink(false)
      window.location.href = url
    }
    return () => {
      setShouldLink(false)
    }
  }, [shouldLink, url])

  const data = undefined // TODO: delete this after implement 'search' query
  // const { data } = useQuery({
  //   type: 'search',
  //   resource: 'payments',
  //   payload: {
  //     ids:
  //       props.record.entries !== undefined
  //         ? props.record.entries
  //             .map((entry) => entry.paymentId)
  //             .filter((paymentId) => paymentId !== undefined)
  //         : undefined,
  //     sort: { field: 'defaultSort', order: 'ASC' },
  //   },
  // })

  const enhancedProps = { ...props, record: entries }

  return (
    <div className={classes.panel}>
      <div className={classes.infoColumn}>
        <Typography className={classes.importerName}>
          {/* <Link to={url} onClick={handleClick}> */}
          <span className={classes.text}>{props.record.importerName}</span>
          {/* </Link> */}
        </Typography>
        <Typography className={classes.invoiceId}>
          {translate('resources.invoices.messages.invoiceNumber').replace(
            '<<invoiceId>>',
            props.record.invoiceNumber
          )}
        </Typography>
        <StatusField
          className={classes.status}
          source={props.record.status}
          {...enhancedProps}
        />
        <StatusDetailTitleField
          className={classes.statusTitle}
          source={props.record.status}
          {...enhancedProps}
        />
        <StatusDetailDescriptionField
          className={classes.statusDescription}
          source={props.record.status}
          {...enhancedProps}
        />
      </div>
      <div className={classes.tableColumn}>
        <ArrayField source="events" {...enhancedProps}>
          <EventInvoiceList linkDataPayments={data} />
        </ArrayField>
      </div>
    </div>
  )
}
